document.addEventListener("DOMContentLoaded", function () {
  window.OMBRAZ_DEBUG = false;
  const valuePropObserver = handleValuePropTest();
});

function handleValuePropTest() {
  const valuePropElements = {
    regular: document.querySelector(".warranty-info:not([data-testgroup])"),
    a: document.querySelector(".warranty-info[data-testgroup='a']"),
    b: document.querySelector(".warranty-info[data-testgroup='b']"),
  };

  if (!Object.values(valuePropElements).some((el) => el)) {
    console.warn("No value prop sections found. Aborting value prop test.");
    return;
  }

  // Check URL parameter on initial load only
  checkInitialValuePropTest(valuePropElements);

  const config = { attributes: true, attributeFilter: ["class"] };

  const callback = function (_mutationList, _observer) {
    // Only check body classes on mutations, not URL parameters
    checkBodyClassValuePropTest(valuePropElements);
  };

  const observer = new MutationObserver(callback);
  observer.observe(document.body, config);

  return observer;
}

function checkInitialValuePropTest(valuePropElements) {
  // Check URL parameter first (only on initial load)
  const urlParams = new URLSearchParams(window.location.search);
  const urlValuePropTest = urlParams.get("testgroup-value-props");

  if (urlValuePropTest && /^[ab]$/.test(urlValuePropTest)) {
    debugLog(`Value prop test from URL parameter: ${urlValuePropTest}`);
    showValueProp(valuePropElements, urlValuePropTest);
    return;
  }

  // If no URL parameter, check body class
  checkBodyClassValuePropTest(valuePropElements);
}

function checkBodyClassValuePropTest(valuePropElements) {
  const bodyClasses = document.body.className;
  const match = bodyClasses.match(/testgroup-value-props-([ab])/);

  if (match) {
    const testVariant = match[1];
    debugLog(`Value prop test from body class: ${testVariant}`);
    showValueProp(valuePropElements, testVariant);
  } else {
    debugLog("No value prop test found, restoring regular value prop");
    showValueProp(valuePropElements, "regular");
  }
}

function showValueProp(valuePropElements, propKey) {
  // Hide all value props first
  Object.values(valuePropElements).forEach((prop) => {
    if (prop) {
      prop.classList.add("hidden");
      prop.style.display = "none";
    }
  });

  // Show selected value prop
  if (valuePropElements[propKey]) {
    valuePropElements[propKey].classList.remove("hidden");
    valuePropElements[propKey].style.display = "";
    debugLog(`Showed value prop: ${propKey}`);
  }
}

function debugLog(message, data = null) {
  if (window.OMBRAZ_DEBUG) {
    console.log(`OMBRAZ DEBUG: ${message}`, data || "");
  }
}
